export default __webpack_public_path__ + "static/media/COVID-19 Antibody Treatment FAQs_100621.e78dedad.pdf";